module.exports = __webpack_public_path__ + "img/firefox.160138bf.svg";